import { render } from "./MazeChaseGame.vue?vue&type=template&id=0cd5a050&scoped=true"
import script from "./MazeChaseGame.vue?vue&type=script&lang=js"
export * from "./MazeChaseGame.vue?vue&type=script&lang=js"

import "./MazeChaseGame.vue?vue&type=style&index=0&id=0cd5a050&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cd5a050"]])

export default __exports__